import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/guard';
import { HSERiskComponent } from './pages/registration/component/hse-risk/hse-risk.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full',
	},

	{
		path: 'download',
		loadChildren: () =>
			import('./pages/download/download.module').then(m => m.DownloadModule),
	},


	{
		path: '404',
		loadChildren: () =>
			import('./pages/404/404.module').then(m => m.NotFoundModule),
	},



	{
		path: 'ewp',
		loadChildren: () =>
			import('./layout/layout.module').then(m => m.LayoutModule),
		canActivate: [AuthGuard]
	},



	{
		path: 'checkin',
		loadChildren: () =>
			import('./pages/checkin/checkin.module').then(m => m.CheckinModule),
			canActivate: [AuthGuard]
	},



	{
		path: 'approve/vms-project',
		loadChildren: () =>
			import('./pages/approve/appove.module').then(m => m.ApproveModule),
			canActivate: [AuthGuard]
	},

	{
		path: 'approve/reject',
		loadChildren: () =>
			import('./pages/approve/appove.module').then(m => m.ApproveModule),
			canActivate: [AuthGuard]
	},

	{
		path: 'reject/vms-project',
		loadChildren: () =>
			import('./pages/reject/reject.module').then(m => m.RejectModule),
			canActivate: [AuthGuard]
	},

	{
		path: 'redirect',
		loadChildren: () =>
			import('./pages/redirect/redirect.module').then(
				m => m.RedirectModule
			)
	},

	{
		path: 'homebase',
		loadChildren: () =>
			import('./pages/homepage/homepage.module').then(
				m => m.HomepageModule
			)
	},

	{
		path: 'login',
		loadChildren: () =>
			import('./pages/login/login.module').then(
				m => m.LoginModule
			),
	},

	{
		path: 'hserisk',
		loadChildren: () =>
			import('./pages/registration/registration.module').then(
				m => m.RegistrationModule
			),
			component: HSERiskComponent
	},
	

];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			useHash: false,
			scrollPositionRestoration: 'top',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
